import { novelAdminHttp } from './http.js'

export function listNovelDramaAssets(pack_id) {
  return novelAdminHttp().get(`/packs/${encodeURIComponent(pack_id)}/drama-assets`, {
    routeId: 'novel.admin.drama.assets.list',
  })
}

export function saveNovelDramaAssetPolicy(pack_id, body) {
  return novelAdminHttp().post(`/packs/${encodeURIComponent(pack_id)}/drama-assets/policy`, {
    body, routeId: 'novel.admin.drama.assets.policy',
  })
}

export function clearNovelDramaAssetLearning(pack_id, body) {
  return novelAdminHttp().post(`/packs/${encodeURIComponent(pack_id)}/drama-assets/clear-learned`, {
    body, routeId: 'novel.admin.drama.assets.clear_learned',
  })
}

export function previewNovelDramaAsset(pack_id, body) {
  return novelAdminHttp().post(`/packs/${encodeURIComponent(pack_id)}/drama-assets/preview`, {
    body, routeId: 'novel.admin.drama.assets.preview',
  })
}

export function listNovelDramaAccounts() {
  return novelAdminHttp().get('/drama/accounts', {
    routeId: 'novel.admin.drama.accounts.list',
  })
}

export function saveNovelDramaAccount(account_fingerprint, body) {
  return novelAdminHttp().post(`/drama/accounts/${encodeURIComponent(account_fingerprint)}`, {
    body, routeId: 'novel.admin.drama.accounts.save',
  })
}
